<template>
  <div class="mt-4 max-w-3xl mx-auto">
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <div class="sm:flex sm:items-start sm:justify-between">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Enjoying our app? ❤️
            </h3>
            <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
              <p>
                I hope our app is useful to your store. We are working hard to
                build this app. Please give us your love by writing a review.
                Thank you from carthike team :)
                <br />
              </p>
            </div>
          </div>
          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150 animate-bounce"
                @click="openReviewPage"
              >
                Write a review
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openReviewPage() {
      window.open(
        "https://apps.shopify.com/whatsapp-abandoned-cart?#modal-show=ReviewListingModal",
        "_blank"
      );
      this.$store.dispatch("updateConfig", {
        requestParams: {
          hasClickedWriteAReview: true
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
